import * as loadingState from '../constants/loadingState';

import { PHONE } from '@dragonfruit/constants/signupAuthType';

export const FORGOT_PASSWORD = 'FORGOT_PASSWORD';
export const FORGOT_PASSWORD_SUCCESS = 'FORGOT_PASSWORD_SUCCESS';
export const FORGOT_PASSWORD_ERROR = 'FORGOT_PASSWORD_ERROR';
export const RESET_FORGOT_PASSWORD = 'RESET_FORGOT_PASSWORD';

const SELECT_AUTH_TYPE = 'SELECT_AUTH_TYPE';

export const forgotPassword = ({
  email,
  locale,
  phoneNumber,
  countryCode,
}) => ({
  type: FORGOT_PASSWORD,
  payload: {
    email,
    locale,
    phoneNumber,
    countryCode,
  },
});

export const forgotPasswordSuccess = () => ({ type: FORGOT_PASSWORD_SUCCESS });

export const forgotPasswordError = errorCode => ({
  type: FORGOT_PASSWORD_ERROR,
  payload: {
    errorCode,
  },
});

export const resetForgotPassword = () => ({ type: RESET_FORGOT_PASSWORD });

export const selectAuthType = authType => ({
  type: SELECT_AUTH_TYPE,
  payload: {
    authType,
  },
});

const INIT_STATE = {
  status: loadingState.EMPTY,
  errorCode: '',
  email: '',
  locale: '',
  authType: PHONE,
};

const reducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case FORGOT_PASSWORD:
      return {
        ...state,
        status: loadingState.LOADING,
      };
    case FORGOT_PASSWORD_SUCCESS:
      return {
        ...state,
        status: loadingState.READY,
        errorCode: '',
      };
    case FORGOT_PASSWORD_ERROR:
      return {
        ...state,
        status: loadingState.ERROR,
        errorCode: action.payload.errorCode,
      };
    case RESET_FORGOT_PASSWORD:
      return {
        ...INIT_STATE,
      };
    case SELECT_AUTH_TYPE:
      return {
        ...state,
        authType: action.payload.authType,
      };
    default:
      return state;
  }
};

export default reducer;

export const getAuthType = state => state.forgotPassword.authType;



// WEBPACK FOOTER //
// ./app/redux/forgotPassword.js